export const StatDisplay = (value:number, suffix?: string): string => {
    if(value >= 0) return `+${value}${suffix ?? ""}`;
    return value.toString();
}